import { memo, useState, useEffect } from 'react';

const CARDS = ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H'];

const MemoryGame = memo(() => {
  const [cards, setCards] = useState([]);
  const [flipped, setFlipped] = useState([]);
  const [matched, setMatched] = useState([]);
  const [moves, setMoves] = useState(0);

  useEffect(() => {
    const shuffled = [...CARDS, ...CARDS]
      .map((c, i) => ({ id: i, emoji: c }))
      .sort(() => Math.random() - 0.5);
    setCards(shuffled);
  }, []);

  const handleFlip = (idx) => {
    if (flipped.length === 2 || flipped.includes(idx) || matched.includes(idx)) return;
    const newFlipped = [...flipped, idx];
    setFlipped(newFlipped);

    if (newFlipped.length === 2) {
      setMoves(m => m + 1);
      if (cards[newFlipped[0]].emoji === cards[newFlipped[1]].emoji) {
        setMatched(m => [...m, ...newFlipped]);
        setFlipped([]);
      } else {
        setTimeout(() => setFlipped([]), 800);
      }
    }
  };

  const won = matched.length === cards.length && cards.length > 0;

  return (
    <div>
      <div className="flex items-center justify-between mb-2">
        <span className="text-xs font-sans font-medium" style={{ color: 'inherit' }}>
          Memory Match {won ? '— You won!' : ''}
        </span>
        <span className="text-xs font-sans" style={{ color: '#8c8782' }}>
          Moves: {moves}
        </span>
      </div>
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: '6px' }}>
        {cards.map((card, i) => (
          <button
            key={card.id}
            onClick={() => handleFlip(i)}
            style={{
              aspectRatio: '1', display: 'flex', alignItems: 'center', justifyContent: 'center',
              fontFamily: 'var(--sans)', fontSize: '20px', fontStyle: 'italic',
              background: flipped.includes(i) || matched.includes(i) ? 'rgba(196,162,101,0.08)' : '#f5f2ee',
              border: `1px solid ${flipped.includes(i) || matched.includes(i) ? '#C9A84C' : '#e8e3dc'}`,
              color: '#C9A84C',
              cursor: 'pointer',
              opacity: matched.includes(i) ? 0.3 : 1,
              transition: 'all .3s',
            }}
          >
            {flipped.includes(i) || matched.includes(i) ? card.emoji : ''}
          </button>
        ))}
      </div>
    </div>
  );
});

MemoryGame.displayName = 'MemoryGame';
export default MemoryGame;
